/* DrinksNation UI: steppers, ladder tier highlight, sticky add-to-cart,
   client-side sort for per-unit price and best-before, search synonyms, bottom-nav search focus.
   Vanilla, no framework. Loads after Dawn's global.js, product-form.js and predictive-search.js. */
(function () {
  var money = function (cents) { return 'S$' + (cents / 100).toFixed(2); };

  function bindStepper(s) {
    if (s.dataset.dnBound) return; s.dataset.dnBound = '1';
    var input = s.querySelector('input[name="quantity"], input[type="number"]');
    var base = Number(s.dataset.price || 0);
    var scope = s.closest('[data-dn-product]') || s.closest('form') || s.parentElement;
    /* max is read on every press, not once: the e-voucher page lowers it as the basket fills (dn-cart.js). */
    function n() { var max = Number(input.getAttribute('max')) || 999; return Math.max(1, Math.min(max, parseInt(input.value, 10) || 1)); }
    function render() {
      var q = n(); input.value = q;
      var unit = base;
      scope.querySelectorAll('[data-dn-atc-label]').forEach(function (b) {
        /* A disabled button carries its reason ("Out of stock", "Past its best-before date"; ADR-033):
           the stepper must not turn it back into "Add 1 carton". */
        var btn = b.closest('button');
        if (btn && btn.disabled) return;
        var short = b.hasAttribute('data-dn-atc-short');
        /* The noun comes from the stepper, not from here: the Chilled Selection sells single
           bottles, and "Add 1 carton" on a 270ml bottle is wrong (11 Sep 2026). Defaults to
           carton, which is what every other product in the catalogue is. */
        var noun = (s.getAttribute('data-noun') || 'carton');
        /* data-noun-plural from dn-sell-unit.liquid (15 Oct 2026): "boxes", not "boxs". */
        var nouns = s.getAttribute('data-noun-plural') || noun + 's';
        b.textContent = 'Add ' + q + ' ' + (q > 1 ? nouns : noun) + (base && !short ? ', ' + money(q * unit) : '');
      });
      scope.querySelectorAll('[data-dn-atc-total]').forEach(function (t) { t.textContent = money(q * unit); });
      scope.querySelectorAll('[data-dn-tier]').forEach(function (r) {
        var lo = Number(r.getAttribute('data-dn-tier')), hi = Number(r.getAttribute('data-dn-tier-max') || 9999);
        r.classList.toggle('is-current', q >= lo && q <= hi);
      });
      // Keep a twin stepper (sticky bar) in step.
      scope.querySelectorAll('[data-dn-stepper] input').forEach(function (i) { if (i !== input && i.value != q) i.value = q; });
    }
    s.querySelector('[data-dn-dec]').addEventListener('click', function () { input.value = n() - 1; render(); });
    s.querySelector('[data-dn-inc]').addEventListener('click', function () { input.value = n() + 1; render(); });
    input.addEventListener('change', render);
    render();
  }
  function bindAll(root) { (root || document).querySelectorAll('[data-dn-stepper]').forEach(bindStepper); }

  /* The free-delivery bar (11 Sep 2026, after RedMart's). Server-rendered for the first
     paint; this keeps it honest afterwards, because the bar is on every template and an AJAX add
     from a tile would otherwise leave it quoting a figure the basket has already passed.

     Drinks only: the deposit and the service fee are excluded, the same basis as dn-free-chip and
     the delivery Function. A bar that counted them would promise free delivery a shopper does not
     get. */
  function freeBar() {
    var bars = document.querySelectorAll('[data-dn-free-bar]');
    if (!bars.length) return;
    var el = bars[0];
    var freeCents = Number(el.getAttribute('data-free-cents') || 0);
    var fee = el.getAttribute('data-fee-handle');
    var dep = el.getAttribute('data-deposit-handle');
    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var system = 0;
        (cart.items || []).forEach(function (i) {
          var h = i.handle || (i.product_handle || '');
          var tags = i.product_tags || [];
          /* An e-voucher (gift_card) is not drinks and never counts towards free delivery (ADR-044). */
          if (h === fee || h === dep || tags.indexOf('dn-system') >= 0 || i.gift_card === true) system += i.final_line_price;
        });
        var drinks = cart.total_price - system;
        var toFree = freeCents - drinks;
        var pct = freeCents > 0 ? Math.max(0, Math.min(100, (drinks / freeCents) * 100)) : 0;
        var html = toFree > 0
          ? 'Get free delivery with <strong>S$' + (toFree / 100).toFixed(2) + '</strong> more'
          : 'You have free delivery';
        // Every instance: the header carries one for the desktop row and one for the phone row.
        bars.forEach(function (bar) {
          bar.hidden = !cart.item_count || drinks <= 0;
          var text = bar.querySelector('[data-dn-free-text]');
          if (text) text.innerHTML = html;
          var fill = bar.querySelector('[data-dn-free-fill]');
          // Next frame, so the fill grows from where it was rather than snapping on unhide. scaleX, not width:
          // a transform does not re-lay the header out on every frame (Sprint 8 design pass).
          if (fill) requestAnimationFrame(function () { fill.style.transform = 'scaleX(' + pct / 100 + ')'; });
        });
      })
      .catch(function () { /* leave the server-rendered text alone */ });
  }

  /* The spend ladder follows the basket (11 Sep 2026: "it should update live", "should also
     show basket value"). The ladder is server-rendered Liquid, so before this it was whatever the
     basket held when the page loaded: change the stepper and the green row and the sentence both
     went stale until a reload.

     The tiers are NOT duplicated here - they are read off the element, where the snippet wrote the
     same single list qa/unit/spend-ladder-copy.test.mjs checks against the domain. Only the wording
     lives in both places, and it is kept to one sentence shape so the two cannot drift far.

     Same basis as the Liquid and as the free-delivery bar: drinks at UNDISCOUNTED prices, deposit
     and service fee excluded, which is what ADR-005 reads the ladder off. */
  /* There is ONE money() in this file, at the top, and it includes the currency. A second
     `function money(cents)` used to live here returning a bare amount, and it lost silently: a
     function declaration is hoisted, then the `var money = function ...` assignment at the top of
     the scope runs and overwrites it. So every caller got the currency-carrying version whatever
     they had read, and the two sites below that added their own 'S$' printed "S$S$137.50"
     (10 Sep 2026: "theres a typo error S$"). Same shape as the `.dn button` specificity
     traps: the source read correctly and the runtime value was something else. */
  function spendLadder() {
    var els = document.querySelectorAll('[data-dn-spend]');
    if (!els.length) return;
    var first = els[0];
    var cents = (first.getAttribute('data-tier-cents') || '').split(',').map(Number);
    var pcts = (first.getAttribute('data-tier-pct') || '').split(',').map(Number);
    if (!cents.length || cents.length !== pcts.length) return;
    var fee = first.getAttribute('data-fee-handle'), dep = first.getAttribute('data-deposit-handle');

    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var drinks = 0;
        (cart.items || []).forEach(function (i) {
          var h = i.handle || i.product_handle || '';
          var tags = i.product_tags || [];
          if (h === fee || h === dep || tags.indexOf('dn-system') >= 0) return;
          // ADR-044: an e-voucher is prepaid money, not on the ladder.
          if (i.gift_card === true) return;
          // ADR-025: a partner line (SKU prefix PTR-, partner.ts isPartnerSku) is not on the ladder.
          if (String(i.sku || '').trim().toUpperCase().indexOf('PTR-') === 0) return;
          // original_line_price: the ladder is read off list prices, never off what it has already taken off.
          drinks += (typeof i.original_line_price === 'number' ? i.original_line_price : i.line_price) || 0;
        });
        var reached = -1;
        for (var k = 0; k < cents.length; k++) if (drinks >= cents[k]) reached = k;

        els.forEach(function (el) {
          /* The table's cards and the basket's chips are both the six bands in order, so one index marks either. */
          var items = el.querySelectorAll('.dn-spend__grid > li, .dn-spend__chips > li');
          items.forEach(function (li, j) {
            var i = j % cents.length;
            var on = i === reached;
            li.classList.toggle('is-current', on);
            if (on) li.setAttribute('aria-current', 'true'); else li.removeAttribute('aria-current');
          });
          /* The undiscounted row carries the highlight while the basket is under the first
             threshold, so the panel always marks exactly one band. It sits OUTSIDE
             .dn-spend__grid precisely so the index loop above stays aligned with the six-entry
             tier list - a seventh grid child would slide every highlight one cell along. */
          var base = el.querySelector('[data-dn-spend-base]');
          if (base) {
            var baseOn = reached < 0;
            base.classList.toggle('is-current', baseOn);
            if (baseOn) base.setAttribute('aria-current', 'true'); else base.removeAttribute('aria-current');
          }
          /* Option B's lead price and bar (layout 'progress'): same half-up integer maths as the Liquid. */
          var baseCents = Number(el.getAttribute('data-base-cents')) || 0;
          var now = el.querySelector('[data-dn-spend-now]');
          /* ADR-031: a multi-buy on this product comes off first, as checkout applies it (the Liquid does the same). */
          var mbKind = el.getAttribute('data-mb-kind') || '';
          var mbQty = Number(el.getAttribute('data-mb-qty')) || 0;
          var mbAmt = Number(el.getAttribute('data-mb-amount')) || 0;
          var pre = baseCents;
          if (mbKind === 'each' && mbAmt > 0) pre = Math.max(0, baseCents - mbAmt);
          else if (mbKind === 'set' && mbQty > 1 && mbAmt > 0) pre = Math.min(baseCents, Math.ceil(mbAmt / mbQty));
          if (now && baseCents > 0) {
            var keep = 100 - (reached >= 0 ? pcts[reached] : 0);
            now.textContent = money(Math.floor((pre * keep + 50) / 100));
          }
          /* The price block's one line (layout 'basket', 23 Sep 2026): shown once the basket reaches a step. */
          if (el.hasAttribute('data-dn-spend-basket')) {
            el.hidden = reached < 0 || !baseCents;
            var pctEl = el.querySelector('[data-dn-spend-pct]');
            if (pctEl && reached >= 0) pctEl.textContent = pcts[reached] + '% off';
            return;
          }
          /* Below the first step the product page names that step in this carton's price instead of the bar (16 Oct 2026). */
          var firstStep = el.querySelector('[data-dn-spend-first]');
          var progress = el.querySelector('[data-dn-spend-progress]');
          if (firstStep && progress) { firstStep.hidden = reached >= 0; progress.hidden = reached < 0; }
          var was = el.querySelector('[data-dn-spend-was]');
          if (was) was.hidden = reached < 0 && pre >= baseCents;
          var bar = el.querySelector('[data-dn-spend-bar]');
          if (bar) bar.style.setProperty('--p', Math.min(1, drinks / cents[cents.length - 1]));
          var note = el.querySelector('[data-dn-spend-note]');
          if (!note) return;
          if (drinks <= 0) {
            /* The standing terms are their own line under the table now and say this already, so
               an empty basket hides the sentence rather than printing it twice. */
            note.textContent = '';
            note.hidden = true;
            return;
          }
          note.hidden = false;
          var msg = reached >= 0 ? '<strong class="dn-spend__hit">' + pcts[reached] + '% off</strong> this basket.' : '';
          if (reached + 1 < cents.length) {
            var gap = cents[reached + 1] - drinks;
            msg += (msg ? ' ' : '') + money(gap) + ' more of drinks and it goes to <strong class="dn-spend__hit">' + pcts[reached + 1] + '%</strong>.';
          } else {
            msg += ' Nothing above this one.';
          }
          note.innerHTML = 'Your basket: <strong>' + money(drinks) + '</strong> of drinks. ' + msg.trim();
        });
      })
      .catch(function () { /* leave the server-rendered ladder alone */ });
  }

  /* Sticky add-to-cart (phone): shows once the main add-to-cart leaves the viewport. */
  function stickyAtc() {
    var main = document.querySelector('[data-dn-atc-main]');
    var sticky = document.querySelector('[data-dn-atc-sticky]');
    if (!main || !sticky || !('IntersectionObserver' in window)) return;
    // The pinned bar is always shown on the phone (FairPrice pattern); CSS hides it from 900px.
    // The sticky button submits the main form.
    var btn = sticky.querySelector('[data-dn-atc-submit]');
    var form = main.querySelector('form');
    if (btn && form) btn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.querySelector('[type=submit]').click(); });
  }

  /* Cart count mirror ([data-dn-cart-count]) lives in dn-cart.js since S3-05: it counts cartons,
     never the deposit units, and refreshes from the dn-cart-data section after every change. */

  /* Collection sort: native options navigate; "unit" and "bb" sort the tiles on this page. */
  function sort() {
    var sel = document.querySelector('[data-dn-sort]');
    if (!sel) return;
    var grid = document.querySelector('[data-dn-grid]');
    var note = document.querySelector('[data-dn-sort-note]');
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var client = opt.getAttribute('data-client');
      if (!client) {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        url.hash = '';
        window.location.href = url.toString();
        return;
      }
      if (!grid) return;
      var items = Array.prototype.slice.call(grid.children);
      items.sort(function (a, b) {
        var ka = Number(a.getAttribute('data-' + client) || 9e12), kb = Number(b.getAttribute('data-' + client) || 9e12);
        return ka - kb;
      });
      items.forEach(function (li) { grid.appendChild(li); });
      if (note) note.textContent = client === 'unit' ? 'Sorted by price per unit within this page.' : 'Sorted by best-before within this page, soonest first.';
      try { history.replaceState(null, '', '#sort=' + client); } catch (e) {}
    });
    var m = /#sort=(unit|bb)/.exec(window.location.hash);
    if (m) { sel.value = 'dn:' + m[1]; sel.dispatchEvent(new Event('change')); }
  }

  /* Search synonyms: expand local phrasing before it hits Shopify. Search & Discovery synonym
     groups (admin) are the real fix; this covers the launch list without an app. */
  var SYNONYMS = [
    [/\bhundred plus\b/i, '100 plus'], [/\b100\s*\+/i, '100 plus'], [/\bmilo tin\b/i, 'milo'], [/\bmilo packet\b/i, 'milo'],
    [/\bmineral water\b/i, 'water'], [/\bsoft ?drinks?\b/i, 'carbonated'], [/\bcoke\b/i, 'coca-cola'], [/\bteh\b/i, 'tea'],
    [/\bkopi\b/i, 'coffee'], [/\bctn\b/i, 'carton'], [/\bpkt\b/i, 'packet']
  ];
  function synonyms() {
    var PS = customElements.get('predictive-search');
    if (!PS || !PS.prototype.getSearchResults) return;
    var orig = PS.prototype.getSearchResults;
    PS.prototype.getSearchResults = function (term) {
      var t = term;
      SYNONYMS.forEach(function (p) { t = t.replace(p[0], p[1]); });
      return orig.call(this, t);
    };
  }

  /* Bottom nav "Search": focus the header field instead of leaving the page. */
  function focusSearch() {
    document.querySelectorAll('[data-dn-focus-search]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var input = document.getElementById('dn-search-input');
        if (!input) return;
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'auto' });
        input.focus();
      });
    });
  }

  /* Desktop category rail: hover opens by CSS; click and keyboard toggle for touch screens and AT. */
  function catmenu() {
    var root = document.querySelector('[data-dn-catmenu]'); if (!root) return;
    var items = root.querySelectorAll('[data-dn-catmenu-item]');
    function closeAll(except) { items.forEach(function (i) { if (i !== except) { i.classList.remove('is-open'); i.querySelector('a').setAttribute('aria-expanded', 'false'); } }); }
    items.forEach(function (item) {
      var link = item.querySelector('a');
      link.addEventListener('click', function (e) {
        var open = item.classList.contains('is-open');
        if (!open && (e.pointerType === 'touch' || window.matchMedia('(hover: none)').matches)) { e.preventDefault(); closeAll(item); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); }
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === ' ') { e.preventDefault(); closeAll(item); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); var first = item.querySelector('.dn-catmenu__panel a'); if (first) first.focus(); }
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); });
  }

  /* Tabbed rails: one panel shown at a time. The ARIA tabs pattern (Sprint 8 design pass, round two): one tab
     in the Tab order, arrows and Home/End move between tabs and show each as they land (automatic activation -
     a panel is a row of tiles already in the page, so showing it costs nothing). */
  function tabs() {
    document.querySelectorAll('[data-dn-tabs]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-dn-tab]')), panels = root.querySelectorAll('[data-dn-panel]');
      function select(t, focus) {
        var i = t.getAttribute('data-dn-tab');
        tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-dn-panel') !== i; });
        /* "See all" opens the collection of the tab now showing (4 Oct 2026) */
        var all = root.querySelector('[data-dn-tabs-all]'), to = t.getAttribute('data-all');
        if (all && to) { all.setAttribute('href', to); all.setAttribute('aria-label', all.getAttribute('data-label') + ': ' + t.textContent.trim()); }
        /* the shown rail measured 0 wide while hidden: its scroll listener re-places the arrows (rails()) */
        root.querySelectorAll('[data-dn-panel="' + i + '"] .dn-rail').forEach(function (r) { r.dispatchEvent(new Event('scroll')); });
        if (focus) t.focus();
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? k + 1 : e.key === 'ArrowLeft' ? k - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
          if (n === null) return;
          e.preventDefault();
          select(tabs[(n + tabs.length) % tabs.length], true);
        });
      });
    });
  }

  /* Galleries and banner rows: dots follow the scroll-snap track; a dot click scrolls to its slide. The dots are
     plain buttons with aria-current on the shown slide, not tabs: tabs promise tabpanels and arrow keys, and a
     dot row has neither (Sprint 8 design pass, round two). */
  function gallery() {
    document.querySelectorAll('[data-dn-gallery]').forEach(galleryOne);
  }
  function galleryOne(g) {
    var track = g.querySelector('[data-dn-gallery-track]'); var dots = g.querySelectorAll('[data-dn-gallery-dots] button');
    if (!track || !dots.length) return;
    var slides = Array.prototype.slice.call(track.children);
    function setActive(i) { dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); }); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) setActive(slides.indexOf(e.target)); });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    /* Slides after the first hold their picture in data-src / data-srcset (dn-banners.liquid, 7 Sep 2026) so the first
       slide's LCP image does not share the phone's bandwidth with four it cannot see; a slide loads as it nears the
       track's view, or at once when an arrow or dot sends the shopper to it. */
    function loadSlide(s) {
      var img = s.querySelector('img[data-dn-slide-lazy]'); if (!img) return;
      s.querySelectorAll('source[data-srcset]').forEach(function (so) { so.srcset = so.getAttribute('data-srcset'); so.removeAttribute('data-srcset'); });
      try { img.fetchPriority = 'low'; } catch (e) {}
      img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); img.removeAttribute('data-dn-slide-lazy');
    }
    if ('IntersectionObserver' in window) {
      var lazy = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { loadSlide(e.target); lazy.unobserve(e.target); } });
      }, { root: track, rootMargin: '0px 30% 0px 30%', threshold: 0.01 });
      slides.forEach(function (s) { if (s.querySelector('img[data-dn-slide-lazy]')) lazy.observe(s); });
    } else {
      window.addEventListener('load', function () { slides.forEach(loadSlide); });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      if (slides[i]) { loadSlide(slides[i]); slides[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: SMOOTH() }); }
      setActive(i);
    }
    function current() { var sel = g.querySelector('[data-dn-gallery-dots] button[aria-current="true"]'); return sel ? Number(sel.dataset.index) || 0 : 0; }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.dataset.index) || 0); }); });
    var prev = g.querySelector('[data-dn-gallery-prev]'), next = g.querySelector('[data-dn-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
  }

  /* Share: Web Share API where it exists, else copy the link. */
  function share() {
    document.querySelectorAll('[data-dn-share]').forEach(function (b) {
      b.addEventListener('click', function () {
        var data = { title: b.dataset.title, url: b.dataset.url };
        if (navigator.share) { navigator.share(data).catch(function () {}); return; }
        if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(function () { b.setAttribute('aria-label', 'Link copied'); });
      });
    });
  }

  /* PDP thumbnails swap the field photo. */
  function thumbs() {
    var wrap = document.querySelector('[data-dn-thumbs]');
    var img = document.querySelector('[data-dn-main-image] img');
    if (!wrap || !img) return;
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-src]'); if (!b) return;
      img.src = b.dataset.src; if (b.dataset.srcset) img.srcset = b.dataset.srcset; img.alt = b.dataset.alt || img.alt;
      wrap.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
    });
  }

  /* Collection sidebar on the phone: "Filter and sort" opens the sort card and the facets. From 900px
     the CSS shows the sidebar and hides the button. The CSS hides the body on the phone from first
     paint (not on this class, which arrived after paint and shifted the grid up: CLS 0.71 on 7 Sep);
     a <noscript> style in the section shows it when there is no JS. */
  function side() {
    var root = document.querySelector('[data-dn-side]'); if (!root) return;
    var btn = root.querySelector('[data-dn-side-toggle]'); if (!btn) return;
    root.classList.add('dn-side--js');
    btn.addEventListener('click', function () {
      var open = root.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Phone side menu (8 Sep 2026): the burger opens it, the overlay, the close button and Escape close it,
     focus goes to the close button and back to the burger, the page stops scrolling behind it. */
  function menu() {
    var root = document.querySelector('[data-dn-menu]'); if (!root) return;
    var opener = document.querySelector('[data-dn-menu-open]'); if (!opener) return;
    var panel = root.querySelector('.dn-menu__panel'), closeBtn = root.querySelector('.dn-menu__close');
    function open() {
      root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); opener.setAttribute('aria-expanded', 'true');
      document.body.classList.add('dn-menu-open');
      (closeBtn || panel).focus();
    }
    function close() {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); opener.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('dn-menu-open');
      opener.focus();
    }
    opener.addEventListener('click', open);
    root.querySelectorAll('[data-dn-menu-close]').forEach(function (el) { el.addEventListener('click', close); });
    /* Tapping outside the menu closes it (16 Oct 2026). iPhone Safari sends no click for a tap on a plain
       div unless it reads as tappable, so the overlay gets a pointer cursor, and a pointerup on it closes too. */
    var overlay = root.querySelector('.dn-menu__overlay');
    if (overlay) {
      overlay.style.cursor = 'pointer';
      overlay.addEventListener('pointerup', function (e) { if (e.target === overlay) close(); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab' || !root.classList.contains('is-open')) return;
      var f = panel.querySelectorAll('a[href], button, summary, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* Header drop-downs (Categories, the postal line on the desktop): <details> that close on an
     outside click or Escape, and one at a time. */
  function dropdowns() {
    var all = document.querySelectorAll('details[data-dn-dropdown]'); if (!all.length) return;
    all.forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) all.forEach(function (o) { if (o !== d) o.removeAttribute('open'); }); });
    });
    document.addEventListener('click', function (e) { all.forEach(function (d) { if (d.open && !d.contains(e.target)) d.removeAttribute('open'); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') all.forEach(function (d) { d.removeAttribute('open'); }); });
  }

  /* Rail arrows (FairPrice's round chevron, 7 Sep 2026): each .dn-rail gets prev/next buttons on
     its parent; a click scrolls one viewport of tiles; each button hides at its end of the rail.
     Every rail gets them, not only one that overflows at load: a tabbed rail's hidden panels measure 0 wide then,
     so House Brands' second tab onwards had no arrows (1 Oct 2026). tabs() re-measures a panel's rail when it
     is shown (a synthetic scroll event); a rail that does not overflow shows neither button. */
  function rails() {
    if (!window.matchMedia('(min-width: 900px)').matches) return;
    document.querySelectorAll('.dn-rail').forEach(function (rail) {
      var host = rail.parentElement; host.classList.add('dn-rail-host');
      function mk(dir) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'dn-rail__arrow dn-rail__arrow--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Scroll back' : 'Scroll forward');
        b.innerHTML = dir === 'prev' ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m15 5-7 7 7 7"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 5 7 7-7 7"/></svg>';
        b.addEventListener('click', function () { rail.scrollBy({ left: (dir === 'prev' ? -1 : 1) * rail.clientWidth * 0.9, behavior: SMOOTH() }); });
        host.appendChild(b); return b;
      }
      var prev = mk('prev'), next = mk('next');
      function update() {
        prev.hidden = rail.scrollLeft <= 4;
        next.hidden = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      }
      rail.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
    });
  }

  /* The phone proof strip scrolls sideways, so a keyboard must be able to reach it (WCAG 2.1.1, axe
     scrollable-region-focusable); where it fits (desktop) the tab stop would lead nowhere, so it goes. */
  function proof() {
    document.querySelectorAll('.dn-proof[tabindex]').forEach(function (u) { if (u.scrollWidth <= u.clientWidth + 1) u.removeAttribute('tabindex'); });
  }

  /* [data-dn-inview] gets .is-in the first time most of it is on screen, once (the voucher heading's ticket,
     4 Oct 2026). The motion itself is CSS and respects reduced motion there; without the observer the element
     simply never moves. */
  function inView() {
    var els = document.querySelectorAll('[data-dn-inview]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    proof(); bindAll(); stickyAtc(); sort(); synonyms(); focusSearch(); thumbs(); gallery(); share(); tabs(); catmenu(); side(); dropdowns(); menu(); rails(); freeBar(); spendLadder(); inView();
    // Steppers injected later (predictive search results, section rerenders).
    new MutationObserver(function () { bindAll(); }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('dn:cart', freeBar);
  document.addEventListener('dn:cart', spendLadder);

  /* Script scrolls bypass the CSS reduced-motion switch, so they ask for themselves. */
  function SMOOTH() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }

  /* A product with more than one variant: picking one reloads on ?variant=, so the price, the per-unit line, the
     deposit, the stock line and the pinned bar are all Liquid's for THAT variant. Nothing here re-priced them,
     and a page that quotes a price the checkout will not charge is the worst failure this build can have
     (Sprint 8 design pass). */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('.dn-atc__variant select')) return;
    var u = new URL(location.href); u.searchParams.set('variant', sel.value); location.replace(u.toString());
  });

  /* Predictive search rows (WCAG AA audit, 22 Sep 2026): the option's <a> carries data-href, not href, because an
     option may not contain a focusable link. Dawn clicks that <a> on Enter; a pointer click anywhere on the row
     lands here too. Ctrl/Cmd or middle click still opens a new tab, as a link would. */
  function openRow(e) {
    var row = e.target.closest && e.target.closest('#predictive-search-results [role="option"]');
    if (!row) return;
    var a = row.querySelector('[data-href]'); if (!a) return;
    var url = a.getAttribute('data-href');
    if (e.type === 'auxclick' || e.ctrlKey || e.metaKey || e.shiftKey) { if (e.button !== 2) window.open(url, '_blank', 'noopener'); return; }
    location.href = url;
  }
  document.addEventListener('click', openRow);
  document.addEventListener('auxclick', function (e) { if (e.button === 1) openRow(e); });

  /* Images are not offered for saving (1 Oct 2026: "prevent right click to save product images"): no context
     menu and no drag on an <img>; long-press is shut off in dn.css. A deterrent only, since the CDN URL is in the page
     source. Right-click everywhere else, text selection and keyboard use are untouched. */
  function noSave(e) { if (e.target.tagName === 'IMG') e.preventDefault(); }
  document.addEventListener('contextmenu', noSave);
  document.addEventListener('dragstart', noSave);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
